export const name = 'builderContextProviders' as const
export const ContextProviderRegistrySymbol = Symbol.for('ContextProviderRegistry')
export const ContextProviderLoaderSymbol = Symbol.for('ContextProviderLoader')
export const BuilderContextProvidersAttachedStoreSymbol = Symbol.for('BuilderContextProvidersAttachedStore')
export const BuilderContextBindingStoreSymbol = Symbol.for('BuilderContextBindingStore')
